export default "__VITE_ASSET__GYB5qoXq__"